/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Accounts module
 * @module AccountsModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    RoleCollection,
    RoleFilterConfigItem,
    RoleItem,
    TenantCollection,
    TenantItem,
    UserCollection,
    UserItem,
    UserProfileCollection,
    UserProfileItem,
} from './factories';

import {
    PasswordGeneratorService,
    RoleService,
} from './services';

import {
    PASSWORD_GENERATOR_SERVICE_TOKEN,
    ROLE_COLLECTION_TOKEN,
    ROLE_FILTER_CONFIG_ITEM_TOKEN,
    ROLE_ITEM_TOKEN,
    ROLE_SERVICE_TOKEN,
    TENANT_COLLECTION_TOKEN,
    TENANT_ITEM_TOKEN,
    USER_COLLECTION_TOKEN,
    USER_ITEM_TOKEN,
    USER_PROFILE_COLLECTION_TOKEN,
    USER_PROFILE_ITEM_TOKEN,
} from './accounts.tokens';

const accountsModule = angular.module('avi/accounts');

const services = [
    {
        service: RoleService,
        name: ROLE_SERVICE_TOKEN,
    },
    {
        service: PasswordGeneratorService,
        name: PASSWORD_GENERATOR_SERVICE_TOKEN,
    },
];

const factories = [
    {
        factory: UserProfileItem,
        name: USER_PROFILE_ITEM_TOKEN,
    },
    {
        factory: UserProfileCollection,
        name: USER_PROFILE_COLLECTION_TOKEN,
    },
    {
        factory: TenantItem,
        name: TENANT_ITEM_TOKEN,
    },
    {
        factory: TenantCollection,
        name: TENANT_COLLECTION_TOKEN,
    },
    {
        factory: RoleItem,
        name: ROLE_ITEM_TOKEN,
    },
    {
        factory: RoleCollection,
        name: ROLE_COLLECTION_TOKEN,
    },
    {
        factory: RoleFilterConfigItem,
        name: ROLE_FILTER_CONFIG_ITEM_TOKEN,
    },
    {
        factory: UserItem,
        name: USER_ITEM_TOKEN,
    },
    {
        factory: UserCollection,
        name: USER_COLLECTION_TOKEN,
    },
];

services.forEach(({ name, service }) => {
    initAjsDependency(accountsModule, 'service', name, service);
});

factories.forEach(({ name, factory }) => {
    initAjsDependency(accountsModule, 'factory', name, factory);
});
